import React from 'react';
import { TbGolf } from "react-icons/tb";
import { IoGolfOutline } from "react-icons/io5";
import { FaFlagCheckered } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import { BiErrorCircle } from "react-icons/bi";

const badgeConfig = {
  'Not Started': { icon: TbGolf, className: 'bg-gray-100 text-gray-600' },
  'In Progress': { icon: IoGolfOutline, className: 'bg-green-100 text-green-700' },
  'Completed': { icon: FaFlagCheckered, className: 'bg-blue-100 text-blue-700' },
  'Official': { icon: MdOutlinePendingActions, className: 'bg-emerald-100 text-emerald-700' },
  'Suspended': { icon: BiErrorCircle, className: 'bg-red-100 text-red-700' },
};

const StatusBadge = ({ status }) => {
  const config = badgeConfig[status] || badgeConfig['Not Started'];
  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${config.className}`}>
      <Icon className="w-3 h-3" />
      {status || 'Not Started'}
    </span>
  );
};

export default StatusBadge;
